export const copyToClipboard = (text) => {
    return navigator.clipboard.writeText(text).then(function () {
        return true
    }, function () {
        return false
    });
}